import { lazy } from "react";

export { DOCUMENT_REGISTER_PATH } from "./document-register-path";
export const DocumentRegisterPage = lazy(
  () => import("./document-register-page"),
);
